//import type { FormEvent } from "react";
import { useMyProfilQuery } from "../../stores/OkOkStore";
import EditProfilForm from "../../components/Profils/EditProfilForm";
import { useTrads } from "../../contexts/trads/useTrads";
function ProfilEdit() {
    const profilQuery = useMyProfilQuery();
    const {translate}=useTrads();
    return (

      profilQuery.error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
      profilQuery.isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
      profilQuery.data &&
      <div>
        <h2>{translate('title_edit_profil')}</h2>
          <EditProfilForm profilParam={profilQuery.data}  />
      </div>
      
    );
}
export default ProfilEdit;
